'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = ['M48 112l0 20.1 208 157.8 208-157.8 0-20.1-416 0zm0 80.3l0 207.7 416 0 0-207.7-193.5 146.8-14.5 11-14.5-11-193.5-146.8z', 'M24 64l-24 0 0 384 512 0 0-384-488 0zm440 64l0 4.1-208 157.8-208-157.8 0-20.1 416 0 0 16zm0 64.3l0 207.7-416 0 0-207.7 193.5 146.8 14.5 11 14.5-11 193.5-146.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;